import { gql, useMutation, useQuery } from "@apollo/client";
import React, { useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  BreadCrumb,
  BreadCrumbProp,
} from "../../../../components/light/Breadcrumb";
import { Content } from "../../../../components/light/Content";
import { SectionBlock } from "../../../../components/light/SectionBlock";
import { Loading } from "../../../../components/Loading";
import { Graphql } from "../../../../graphql/_graphql";
import { Toast } from "../../../../hooks/toast";

const QUERY_SEARCH_PRODUCT = gql`
  query merchantSearchProduct($keyword: String) {
    merchantSearchProduct(keyword: $keyword)
  }
`;

const MUTATION_FEED_CREATE = gql`
  mutation merchantCreateFeed($data: MerchantFeedInput) {
    merchantCreateFeed(data: $data)
  }
`;

const MUTATION = gql`
  mutation merchantUpdateFeed($feedId: Int!, $data: MerchantFeedInput) {
    merchantUpdateFeed(feedId: $feedId, data: $data)
  }
`;

function SearchProductCode({onSearchComplete}: { onSearchComplete: (e: any) => void }){
  const [code, setCode] = useState("");
  const [codeInput, setCodeInput] = useState("");
  
  const { loading } = useQuery(QUERY_SEARCH_PRODUCT, {
    skip: !code,
    variables: {
      keyword: code
    },
    fetchPolicy: 'no-cache',
    onCompleted: res => {
      onSearchComplete(res.merchantSearchProduct[0]);
      setCode("");
    }
  });

  return(
    <div className="input-group mb-3">
      <label>{loading ? '.....': ''}</label>
      <input
        className="form-control"
        placeholder="Enter l192 code"
        value={codeInput}
        onChange={(e) => setCodeInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.keyCode === 13) {
            setCode(codeInput);
            setCodeInput("");
          }
        }}
      />
      <button 
        className="btn btn-primary" 
        style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
        onClick={()=>{
          if(codeInput){
            setCode(codeInput);
            setCodeInput("");
          }
        }}
      >Add</button>
    </div>
  )
}

export function FeedCreateScreen() {
  let refTextArea: any;
  const { push } = useHistory();
  const { params }: any = useRouteMatch();
  const [items, setItems] = useState<any[]>([]);
  const [execute] = useMutation(
    params.id === undefined ? MUTATION_FEED_CREATE : MUTATION,
    {
      onCompleted: (res) => {
        if (res.merchantUpdateFeed || res.merchantCreateFeed) {
          push("/feed");
        }
      },
    }
  );
  const { loading, data } = useQuery(Graphql.Query.QUERY_MERCHANT_FEED, {
    skip: params.id === undefined,
    fetchPolicy: "no-cache",
    variables: {
      feedId: Number(params.id),
    },
    onCompleted: (res) => {
      setItems(res.merchantFeed.item);
    },
  });

  const BreadCrumbItems: BreadCrumbProp[] = [
    {
      text: "Applications",
      to: "#",
    },
    {
      text: "Products",
      to: "#",
    },
    {
      text: "Feed",
      to: "/feed",
    },
    {
      text: params.id === undefined ? "Create" : "Edit",
      to: params.id === undefined ? "/feed/create" : "/feed/edit",
    },
  ];

  const handleOnSubmit = (e: any) => {
    e.preventDefault();
    const data = {
      text: refTextArea.value,
      itemId: items.map((x) => x.itemid),
    };

    if(data.itemId.length > 0) {
      if (params.id === undefined) {
        execute({
          variables: {
            data,
          },
        });
      } else {
        execute({
          variables: {
            feedId: Number(params.id),
            data,
          },
        });
      }
    }
    else {
      Toast.onShow('Please select item product', 'danger', 'right');
    }
  };

  if (loading) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <SectionBlock
          title={
            params.id === undefined
              ? "Create New Feed"
              : "Edit Feed #" + params.id
          }
          transparent={true}
        >
          <Loading />
        </SectionBlock>
      </Content>
    );
  }

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-6">
          <SectionBlock
            title={
              params.id === undefined
                ? "Create New Feed"
                : "Edit Feed #" + params.id
            }
            transparent={true}
          >
            <form onSubmit={handleOnSubmit}>
              <div className="row">
                <div className="col-md-6"></div>
                <div className="col-md-6 text-right">
                  <button type="submit" className="btn btn-secondary btn-sm">
                    {params.id === undefined ? "Create" : "Save"}
                  </button>
                </div>
              </div>
              <br />
              <div className="form-group">
                <label>Description</label>
                <textarea
                  className="form-control"
                  placeholder="Text Somthing"
                  defaultValue={data ? data.merchantFeed.text : ""}
                  autoFocus
                  ref={(ref) => (refTextArea = ref)}
                ></textarea>
              </div>
            </form>
            <SearchProductCode onSearchComplete={e => setItems([...items, e])}/>
            <table className="table table-padded">
              <tbody>
                {items.map((x: any, i: number) => {
                  return (
                    <tr key={i}>
                      <td>
                        <div className="cell-image-list">
                          <div
                            className="cell-img"
                            style={{
                              backgroundImage: `url(${x.thumb_small})`,
                            }}
                          ></div>
                        </div>
                        <small style={{ marginLeft: 20 }}>{x.code}</small>
                      </td>
                      <td className="text-center">
                        <Link
                          to="#"
                          className="text-danger"
                          onClick={() => {
                            setItems(
                              items.filter(
                                (item: any) => item.itemid !== x.itemid
                              )
                            );
                          }}
                        >
                          Remove
                        </Link>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </SectionBlock>
        </div>
      </div>
    </Content>
  );
}
